import { SvgIcon } from "@mui/material";
import { CSSProperties } from "react";

const EditIcon = ({ scale, color, style }: { scale?: number; color?: string; style?: CSSProperties }) => {
  let c = "#1062D0";
  if (color) c = color;
  return (
    <SvgIcon
      style={{ transform: `scale(${scale || 1})`, fill: "none" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.747 18.443H19"
        stroke={c}
        strokeWidth="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        clip-rule="evenodd"
        d="M10.78 1.795a2.245 2.245 0 0 1 3.116-.303l1.733 1.347a2.142 2.142 0 0 1 .72 2.984c-.034.054-9.537 11.942-9.537 11.942a1.699 1.699 0 0 1-1.31.632l-3.638.046-.82-3.47a1.63 1.63 0 0 1 .316-1.396l9.42-11.782Z"
        stroke={c}
        strokeWidth="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="m9.02 4 5.453 4.188"
        stroke={c}
        strokeWidth="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </SvgIcon>
  );
};

export default EditIcon;
